import { ChangeDetectionStrategy, Component, input, output } from "@angular/core";

import { Button } from "primeng/button";

@Component({
  selector: "rr-ui-core-not-found",
  imports: [Button],
  templateUrl: "./ui-core-not-found.component.html",
  styleUrl: "./ui-core-not-found.component.scss",
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class UiCoreNotFoundComponent {
  // I/O
  hasTheme = input<boolean>();
  eventLabel = input<string>("Go back to Home");
  notFound = output<void>();
}
